<!--
=========================================================
* Vue Material Dashboard 2 Laravel PRO - v3.0.0
=========================================================

* Product Page: https://creative-tim.com/product/vue-material-dashboard-2-pro
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
-->
<template>
  <sidenav
    v-if="showSidenav"
    :custom_class="color"
    :class="[isRTL ? 'fixed-end' : 'fixed-start']"
  />
  <main
    class="main-content position-relative h-100 overflow-x-hidden"
  >
    <!-- nav -->
    <navbar
      v-if="showNavbar"
      :class="[isNavFixed ? navbarFixed : '', isAbsolute ? absolute : '']"
      :color="isAbsolute ? 'text-white opacity-8' : ''"
      :min-nav="navbarMinimize"
    />
    <router-view />
    <app-footer v-show="showFooter" />
    <!-- <configurator
      :toggle="toggleConfigurator"
      :class="[showConfig ? 'show' : '', hideConfigButton ? 'd-none' : '']"
    /> -->
  </main>
  <toast-container />
  <pull-to-refresh />
  <terms-acceptance-modal ref="termsModal" />
</template>
<script>
import Sidenav from "./examples/Sidenav";
// import Configurator from "@/examples/Configurator.vue";
import Navbar from "@/examples/Navbars/Navbar.vue";
import AppFooter from "@/examples/Footer.vue";
import { mapMutations, mapState } from "vuex";
import ToastContainer from "@/components/Toast/ToastContainer.vue";
import PullToRefresh from "@/components/PullToRefresh.vue";
import TermsAcceptanceModal from "@/components/TermsAcceptanceModal.vue";
import authService from "./services/authService";
import { activateDarkMode } from "@/assets/js/dark-mode";

export default {
  name: "App",
  components: {
    Sidenav,
    // Configurator,
    Navbar,
    AppFooter,
    ToastContainer,
    PullToRefresh,
    TermsAcceptanceModal
  },
  data() {
    return {
      termsChecked: false,
    };
  },
  computed: {
    ...mapState([
      "isRTL",
      "color",
      "isAbsolute",
      "isNavFixed",
      "navbarFixed",
      "absolute",
      "showSidenav",
      "showNavbar",
      "showFooter",
      "showConfig",
      "hideConfigButton"
    ])
  },
  beforeMount() {
    const sidenav = document.getElementsByClassName("g-sidenav-show")[0];

    if (window.innerWidth > 1200) {
      sidenav.classList.add("g-sidenav-pinned");
    }

    // Restore dark mode preference across refreshes
    if (localStorage.getItem('darkMode') === 'true') {
      this.$store.state.isDarkMode = true;
      activateDarkMode();
    }
  },
  mounted() {
    this.$router.afterEach(() => {
      if (authService.data.isAuthenticated && !this.termsChecked) {
        this.termsChecked = true;
        this.$refs.termsModal?.checkStatus();
      }
      if (!authService.data.isAuthenticated) {
        this.termsChecked = false;
      }
    });
  },
  methods: {
    ...mapMutations(["toggleConfigurator", "navbarMinimize"])
  }
};
</script>
<style>
.dataTable-pagination-list .active a {
  background-image: linear-gradient(
    195deg,
    #66bb6a 0%,
    #43a047 100%
  ) !important;
}
</style>
